import { useCallback, useState } from 'react';

import { useMutation } from '@tanstack/react-query';

import { getAdministrationAuditLogs } from '../api';
import { PageParams } from '../types/pagination';

export const useAdministrationAuditLogs = () => {
  const [lastParams, setLastParams] = useState<PageParams | null>(null);

  const mutation = useMutation({
    mutationKey: ['getAdministrationAuditLogs'],
    mutationFn: (params: PageParams) => {
      setLastParams(params);
      return getAdministrationAuditLogs(params);
    },
  });

  const retryLast = useCallback(() => {
    if (lastParams !== null) {
      mutation.mutate(lastParams);
    }
  }, [lastParams, mutation]);

  return { ...mutation, retryLast };
};
